import Vue from 'vue';
import Router from 'vue-router';
import trackFacebookPageView from '../tracking/facebookPageView';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: []
});

router.afterEach((to, from) => {
    if (from.matched.length === 0) {
        return;
    }
    trackFacebookPageView();
});

export default router;
